import type {CanvasBackend, Context2D, DecodedSource} from './canvas-backend';

const fromBitmap = (bitmap: ImageBitmap): DecodedSource => ({
  source: bitmap,
  width: bitmap.width,
  height: bitmap.height,
  release: () => bitmap.close(),
});

/**
 * Engines that only know `none | flipY` throw a `TypeError` on `'from-image'`;
 * they orient by default, and the session probe confirms either way.
 */
const decodeBitmap = async (blob: Blob): Promise<ImageBitmap> => {
  try {
    return await createImageBitmap(blob, {imageOrientation: 'from-image'});
  } catch (cause) {
    if (cause instanceof TypeError) {
      return createImageBitmap(blob);
    }
    throw cause;
  }
};

/** Works in a Worker and on the main thread wherever `OffscreenCanvas` exists. */
export const offscreenCanvasBackend: CanvasBackend<OffscreenCanvas> = {
  createCanvas: (width, height) => new OffscreenCanvas(width, height),
  getContext: (canvas): Context2D | null => canvas.getContext('2d'),
  decode: async blob => fromBitmap(await decodeBitmap(blob)),
  toBlob: (canvas, type, quality) => canvas.convertToBlob({type, quality}),
};
